import { course_semesters_for_selectQuery } from '@app-types/graphql-types';
import { HSMSSelectOption } from '@components/shared';
import { semesterToWords } from '@functions/semesterToWords';

export const getCourseSemestersForSelect = (
  courses?: course_semesters_for_selectQuery['course_semester'],
  returnId?: boolean,
): HSMSSelectOption[] => {
  if (courses) {
    const semesters = courses.map((semester) => {
      return {
        value: returnId ? semester.id : semester.semester,
        label: semesterToWords(semester.semester),
      };
    });

    return semesters.sort((firstSem, secondSem) => {
      const firstSemValue = parseInt(firstSem.value.split(':').join(''), 10);
      const secondSemValue = parseInt(secondSem.value.split(':').join(''), 10);

      return firstSemValue - secondSemValue;
    });
  }

  return [];
};
